import type { ColumnDef } from '@tanstack/vue-table'
import { h } from 'vue'

import DataTableGoto from 'pejer/src/components/Table/core/DataTableGoto.vue'
import { getDefaultColumn } from 'pejer/src/helpers'
import { Payout } from 'pejer/src/tables/Payout'
import { getColumnByStringIndex } from 'pejer/src/utils'

export const payoutsColumns: ColumnDef<Payout.ListItem>[] = [
  {
    accessorKey: 'shortDescription',
  },
  {
    accessorKey: 'amount',
  },
  {
    accessorKey: 'payoutFee',
  },

  {
    accessorKey: 'insertTime',
    header: 'Created',
  },
  {
    id: 'actions',
    meta: {
      placement: 'end',
    },
    size: 40,
    cell: ({ row }) => {
      const payout = row.original

      return h(
        'div',
        { style: { display: 'flex', justifyContent: 'end' } },
        h(DataTableGoto, {
          name: 'Payout',
          id: getColumnByStringIndex(payout, getDefaultColumn('payouts').id),
          pathName: 'payout',
        })
      )
    },
  },
]
